
































import Vue, { PropType } from 'vue';
import { Step } from '@/models/stepper';

export default Vue.extend({
  name: 'AStepper',
  props: {
    items: { type: Array as PropType<Step[]>, required: true },
    value: { type: [String, Number], required: true },
    nonLinear: Boolean,
    vertical: Boolean,
  },
  methods: {
    isDisabledItem(item: Step, index: number): boolean {
      const previousNonDisabledItem = this.items.slice(0, index).reverse()
        .find(({ disabled }) => !disabled);

      return item.disabled ?? !(this.nonLinear || previousNonDisabledItem?.filled || item.filled
        || item.id === this.value);
    },
  },
});
